/**文献对比分析 */
<template>
  <div class="literature-comparison">
    <div
      class="aside-box"
      :class="{
        'aside-box-hidden': !ifShowHistorys,
      }"
    >
      <div class="fit">
        <AsideHistoryList
          type="COMPARE"
          :activeUid="literatureComparisonUid"
          @click="goComparisonDetail"
        />
      </div>
    </div>
    <div
      class="main-box"
      :class="{
        'main-box-expanded': ifShowHistorys,
      }"
    >
      <div
        class="close-aside-arrow"
        @click="closeHistorys"
        v-if="ifShowHistorys && !ifLoading"
      >
        <el-tooltip content="收起" placement="right" effect="dark">
          <i class="iconfont icon-a-Frame1364" />
        </el-tooltip>
      </div>
      <div
        class="open-aside-arrow"
        @click="openHistorys"
        v-if="!ifShowHistorys"
      >
        <el-tooltip content="查看历史记录" placement="right" effect="dark">
          <i class="iconfont icon-a-Frame1364" />
        </el-tooltip>
      </div>
      <div class="header-box">
        <HeaderBar
          :id="literatureComparisonUid"
          :title="comparisonTitle"
          @go-review="goReview"
          @export="handleExportComparison"
        />
      </div>
      <div class="content-box">
        <div class="content-table">
          <div class="table-action-bar">
            <TableActionBar
              ref="tableActionBarRef"
              :id="literatureComparisonUid"
              :comparisonItems="comparisonItemsList"
              @delete="handleDeleteComparison"
              @update="handleUpdateTableColumns"
              @loading="handleUpdateLoadingStatus"
              @refresh="handleUpdateComparisonList"
            />
          </div>
          <div class="table">
            <CompareTable
              ref="compareTableRef"
              :id="literatureComparisonUid"
              :tableColumns="tableColumns"
              :tableData="tableData"
              :tableStyle="tableStyle"
              :ifLoading="ifLoading"
              :readingResultUpdateTimeMap="readingResultUpdateTimeMap"
              @select="getSelectedIdList"
              @update="handleUpdateComparisonItems"
              @refresh="getComparisonResult"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, provide, ref, watch } from "vue";
import { httpPost, baseUrl } from "@/api/httpService.js";
import { confirmBox } from "@/utils/messageBox.js";
import { COMPARE_TITLE_MAP } from "@/constant/compare.js";
import TableActionBar from "./detail/TableActionBar.vue";
import CompareTable from "./detail/CompareTable.vue";
import HeaderBar from "./detail/HeaderBar.vue";
import { COMPARE_TITLE_VISIBLE } from "@/constant/compare.js";
import { ElMessage } from "element-plus";
import { useRoute, useRouter } from "vue-router";
import { LINE_HEIGHT_TYPE } from "@/constant/compare.js";
import { SYSTEM_STYLE } from "@/constant/compare.js";
import AsideHistoryList from "@/components/literature/AsideHistoryList.vue";

const router = useRouter();
const route = useRoute();
const tableColumns = ref([]); //表头
const tableData = ref([]); //表格数据
const tableStyle = ref({}); //表格样式
const comparisonItemsList = ref([]); //比较项数据
const ifLoading = ref(false);
const literatureUidList = ref([]); //文献uid
const literatureComparisonUid = ref(route.params.uid); //文献对比uid
const readingResultUpdateTimeMap = ref({}); //ai阅读更新时间map
//获取选择的id
const idSelectedList = ref([]);
const getSelectedIdList = (value) => {
  idSelectedList.value = value;
};
//数据格式的方法
const formatdata = (result) => {
  literatureUidList.value = [];
  //表头数据
  let data = result.title.map((item) => {
    return {
      ...item,
      label: COMPARE_TITLE_MAP[item.name]
        ? COMPARE_TITLE_MAP[item.name]
        : item.name,
    };
  });
  tableColumns.value = data.filter((item) => {
    return item.show == COMPARE_TITLE_VISIBLE.SHOW;
  });
  comparisonItemsList.value = data;
  //表格样式
  tableStyle.value = result.style;
  //初始化系统默认
  tableStyle.value.columnWidth = SYSTEM_STYLE.WIDTH;
  tableStyle.value.lineHeight = SYSTEM_STYLE.HEIGHT;
  tableStyle.value.lineHeightType = LINE_HEIGHT_TYPE.NOFIT;
  tableStyle.value.ifDefault = true;
  //表格数据
  tableData.value = result.data.map((item) => {
    literatureUidList.value.push(item.literatureUId);
    const data = item.content.reduce((acc, curr) => {
      return { ...acc, [curr.title]: curr };
    }, {});
    return {
      title: item.literatureTitle,
      authors: item.literatureAuthors,
      literatureUId: item.literatureUId,
      readCompareTime: item.readCompareTime,
      ...data,
    };
  });
};

//获取刷新列表之后结果
const comparisonTitle = ref("");
const getComparisonResult = async () => {
  ifLoading.value = true;
  let params = {
    comparisonUid: literatureComparisonUid.value,
  };
  let res = await httpPost("/comparison/v1/getComparisonResult", params);
  if (res.code == 0) {
    readingResultUpdateTimeMap.value = res.data.readingResultUpdateTimeMap;
    comparisonTitle.value = res.data.title;
    //表头数据
    let result = res.data.result;
    formatdata(result);
  }
  ifLoading.value = false;
};
//删除对比的文献
const handleDeleteComparison = async () => {
  if (idSelectedList.value.length > 0) {
    confirmBox(
      `确定在文献对比中删除${idSelectedList.value.length}篇文献吗？`
    ).then(async () => {
      let params = {
        comparisonUid: literatureComparisonUid.value,
        literatureUids: idSelectedList.value,
      };
      let res = await httpPost(
        "/comparison/v1/deleteComparisonByLiteratureUid",
        params
      );
      if (res.code == 0) {
        ElMessage.success("删除成功");
        getComparisonResult();
      }
    });
  } else {
    ElMessage.warning("请选择文献");
  }
};
//更新表头
const handleUpdateTableColumns = (params) => {
  tableColumns.value = params.data;
  if (params.type == "ADD") {
    const addCompareItemName = tableColumns.value.slice(-1)[0].name;
    tableData.value = tableData.value.map((item) => {
      return {
        ...item,
        [addCompareItemName]: {
          title: addCompareItemName,
          data: null,
        },
      };
    });
  }
};
//更新比较项
const handleUpdateComparisonItems = (params) => {
  tableColumns.value = params.data;
  if (params.type == "ADD") {
    const addCompareItem = tableColumns.value.slice(-1)[0];
    comparisonItemsList.value.push(addCompareItem);
    tableData.value = tableData.value.map((item) => {
      return {
        ...item,
        [addCompareItem.name]: {
          title: addCompareItem.name,
          data: null,
        },
      };
    });
  }
};
//更新loading的状态
const handleUpdateLoadingStatus = (value) => {
  ifLoading.value = value;
};
//添加文献
const handleUpdateComparisonList = (idList) => {
  idList.forEach((item) => {
    literatureUidList.value.push(item);
  });
  getComparisonResult();
};
//获取文献综述Uid
const literatureReviewUid = ref("");
const getAiliteratureReviewUid = async () => {
  let params = {
    literatureUidList: idSelectedList.value,
  };
  let res = await httpPost("/review/v1/addReview", params);
  if (res.code == 0) {
    literatureReviewUid.value = res.data.reviewUid;
  }
};
//打开文献综述
const goReview = async () => {
  if (idSelectedList.value.length == 0) {
    ElMessage.warning("请选择文献");
  } else {
    await getAiliteratureReviewUid();
    if (literatureReviewUid.value) {
      router.push({
        name: "ReviewDetail",
        params: {
          uid: literatureReviewUid.value,
        },
      });
    }
  }
};
//导出
const handleExportComparison = async () => {
  let params = {
    comparisonUid: literatureComparisonUid.value,
  };
  let res = await httpPost("/comparison/v1/exportExcel", params);
  if (res.code == 0) {
    window.location.href = baseUrl + res.data.path;
    ElMessage.success("导出成功");
  }
};

watch(
  () => route.params.uid,
  (newVal, oldVal) => {
    if (newVal) {
      literatureComparisonUid.value = newVal;
      getComparisonResult();
    }
  },
  { immediate: true, deep: true }
);

//左侧历史记录是否显示
const ifShowHistorys = ref(false);
const tableActionBarRef = ref(null);
const compareTableRef = ref(null);
const closeHistorys = () => {
  ifShowHistorys.value = false;
  tableActionBarRef.value.closeAllPopovers();
  compareTableRef.value.closePopovers();
};
const openHistorys = () => {
  ifShowHistorys.value = true;
  tableActionBarRef.value.closeAllPopovers();
  compareTableRef.value.closePopovers();
};
//前往文献对比
const goComparisonDetail = async (row) => {
  router.push({
    name: "CompareDetail",
    params: {
      uid: row.aicomparisonUid,
    },
  });
  ifShowHistorys.value = false;
  literatureComparisonUid.value = row.aicomparisonUid; //文献综述uid
  await getComparisonResult();
};
</script>

<style lang="scss" scoped>
$table-action-bar-height: 48px;
$header-bar-height: 60px;
.literature-comparison {
  height: calc(100vh - $header-height);
  display: flex;
  .aside-box {
    height: 100%;
    width: $page-aside-width;
    background-color: #ffffff;
    transition: all 0.3s;
    overflow: hidden;
    visibility: visible;
    .fit {
      width: $page-aside-width;
      height: 100%;
      padding: 15px 10px;
    }
  }
  //展示、影藏侧边栏
  .close-aside-arrow {
    left: calc($page-aside-width - 2px);
  }
  .open-aside-arrow {
    left: 0px;
  }
  .main-box {
    flex: 1;
    height: 100%;
    transition: all 0.3s;
    .header-box {
      height: $header-bar-height;
      width: 100%;
      background-color: #ffffff;
    }
    .content-box {
      height: calc(100% - $header-bar-height);
      width: 100%;
      padding: 16px;
      .content-table {
        background-color: #fff;
        height: 100%;
        .table-action-bar {
          height: $table-action-bar-height;
        }
        .table {
          width: calc(100vw - 32px);
          transition: all 0.3s;
          height: calc(100% - $table-action-bar-height);
        }
      }
    }
  }
  .aside-box-hidden {
    width: 0px;
    visibility: hidden;
  }
  .main-box-expanded {
    .content-box {
      .content-table {
        .table {
          width: calc(100vw - 272px);
        }
      }
    }
  }
}
</style>
